let __flarum_default_export__;
// Professions, industries and fields of study (generated with resources/taxonomy.json; keep the keys in sync)
export default __flarum_default_export__ = {
  "professions": [{
    "key": "medical-doctor",
    "name": "Medical doctor",
    "group": "Health"
  }, {
    "key": "nurse",
    "name": "Nurse",
    "group": "Health"
  }, {
    "key": "midwife",
    "name": "Midwife",
    "group": "Health"
  }, {
    "key": "pharmacist",
    "name": "Pharmacist",
    "group": "Health"
  }, {
    "key": "dentist",
    "name": "Dentist",
    "group": "Health"
  }, {
    "key": "medical-laboratory-scientist",
    "name": "Medical laboratory scientist",
    "group": "Health"
  }, {
    "key": "physiotherapist",
    "name": "Physiotherapist",
    "group": "Health"
  }, {
    "key": "radiographer",
    "name": "Radiographer",
    "group": "Health"
  }, {
    "key": "optometrist",
    "name": "Optometrist",
    "group": "Health"
  }, {
    "key": "public-health-professional",
    "name": "Public health professional",
    "group": "Health"
  }, {
    "key": "community-health-worker",
    "name": "Community health worker",
    "group": "Health"
  }, {
    "key": "civil-engineer",
    "name": "Civil engineer",
    "group": "Engineering"
  }, {
    "key": "electrical-electronic-engineer",
    "name": "Electrical / electronic engineer",
    "group": "Engineering"
  }, {
    "key": "mechanical-engineer",
    "name": "Mechanical engineer",
    "group": "Engineering"
  }, {
    "key": "chemical-engineer",
    "name": "Chemical engineer",
    "group": "Engineering"
  }, {
    "key": "petroleum-engineer",
    "name": "Petroleum engineer",
    "group": "Engineering"
  }, {
    "key": "structural-engineer",
    "name": "Structural engineer",
    "group": "Engineering"
  }, {
    "key": "computer-engineer",
    "name": "Computer engineer",
    "group": "Engineering"
  }, {
    "key": "telecommunications-engineer",
    "name": "Telecommunications engineer",
    "group": "Engineering"
  }, {
    "key": "agricultural-engineer",
    "name": "Agricultural engineer",
    "group": "Engineering"
  }, {
    "key": "mining-engineer",
    "name": "Mining engineer",
    "group": "Engineering"
  }, {
    "key": "biomedical-engineer",
    "name": "Biomedical engineer",
    "group": "Engineering"
  }, {
    "key": "software-developer",
    "name": "Software developer",
    "group": "Technology"
  }, {
    "key": "data-analyst-scientist",
    "name": "Data analyst / scientist",
    "group": "Technology"
  }, {
    "key": "cybersecurity-professional",
    "name": "Cybersecurity professional",
    "group": "Technology"
  }, {
    "key": "it-support-network-administrator",
    "name": "IT support / network administrator",
    "group": "Technology"
  }, {
    "key": "cloud-devops-engineer",
    "name": "Cloud / DevOps engineer",
    "group": "Technology"
  }, {
    "key": "product-manager",
    "name": "Product manager",
    "group": "Technology"
  }, {
    "key": "ui-ux-designer",
    "name": "UI / UX designer",
    "group": "Technology"
  }, {
    "key": "accountant",
    "name": "Accountant",
    "group": "Finance & business"
  }, {
    "key": "auditor",
    "name": "Auditor",
    "group": "Finance & business"
  }, {
    "key": "banker",
    "name": "Banker",
    "group": "Finance & business"
  }, {
    "key": "financial-analyst",
    "name": "Financial analyst",
    "group": "Finance & business"
  }, {
    "key": "investment-professional",
    "name": "Investment professional",
    "group": "Finance & business"
  }, {
    "key": "insurance-professional",
    "name": "Insurance professional",
    "group": "Finance & business"
  }, {
    "key": "entrepreneur-business-owner",
    "name": "Entrepreneur / business owner",
    "group": "Finance & business"
  }, {
    "key": "management-consultant",
    "name": "Management consultant",
    "group": "Finance & business"
  }, {
    "key": "sales-marketing-professional",
    "name": "Sales / marketing professional",
    "group": "Finance & business"
  }, {
    "key": "human-resources-professional",
    "name": "Human resources professional",
    "group": "Finance & business"
  }, {
    "key": "procurement-supply-chain-professional",
    "name": "Procurement / supply chain professional",
    "group": "Finance & business"
  }, {
    "key": "lawyer",
    "name": "Lawyer",
    "group": "Law & public service"
  }, {
    "key": "judicial-officer",
    "name": "Judicial officer",
    "group": "Law & public service"
  }, {
    "key": "civil-servant",
    "name": "Civil servant",
    "group": "Law & public service"
  }, {
    "key": "police-military-security",
    "name": "Police / military / security",
    "group": "Law & public service"
  }, {
    "key": "diplomat",
    "name": "Diplomat",
    "group": "Law & public service"
  }, {
    "key": "politician-public-office-holder",
    "name": "Politician / public office holder",
    "group": "Law & public service"
  }, {
    "key": "teacher",
    "name": "Teacher",
    "group": "Education & research"
  }, {
    "key": "lecturer-professor",
    "name": "Lecturer / professor",
    "group": "Education & research"
  }, {
    "key": "researcher-scientist",
    "name": "Researcher / scientist",
    "group": "Education & research"
  }, {
    "key": "school-administrator",
    "name": "School administrator",
    "group": "Education & research"
  }, {
    "key": "architect",
    "name": "Architect",
    "group": "Built environment"
  }, {
    "key": "quantity-surveyor",
    "name": "Quantity surveyor",
    "group": "Built environment"
  }, {
    "key": "estate-surveyor-real-estate",
    "name": "Estate surveyor / real estate",
    "group": "Built environment"
  }, {
    "key": "urban-planner",
    "name": "Urban planner",
    "group": "Built environment"
  }, {
    "key": "builder-contractor",
    "name": "Builder / contractor",
    "group": "Built environment"
  }, {
    "key": "geologist-geoscientist",
    "name": "Geologist / geoscientist",
    "group": "Energy & resources"
  }, {
    "key": "oil-gas-technician",
    "name": "Oil & gas technician",
    "group": "Energy & resources"
  }, {
    "key": "renewable-energy-professional",
    "name": "Renewable energy professional",
    "group": "Energy & resources"
  }, {
    "key": "farmer",
    "name": "Farmer",
    "group": "Agriculture"
  }, {
    "key": "agronomist",
    "name": "Agronomist",
    "group": "Agriculture"
  }, {
    "key": "veterinarian",
    "name": "Veterinarian",
    "group": "Agriculture"
  }, {
    "key": "livestock-fisheries",
    "name": "Livestock / fisheries",
    "group": "Agriculture"
  }, {
    "key": "journalist",
    "name": "Journalist",
    "group": "Media & creative"
  }, {
    "key": "content-creator",
    "name": "Content creator",
    "group": "Media & creative"
  }, {
    "key": "musician-artist",
    "name": "Musician / artist",
    "group": "Media & creative"
  }, {
    "key": "actor-filmmaker",
    "name": "Actor / filmmaker",
    "group": "Media & creative"
  }, {
    "key": "fashion-designer",
    "name": "Fashion designer",
    "group": "Media & creative"
  }, {
    "key": "photographer-videographer",
    "name": "Photographer / videographer",
    "group": "Media & creative"
  }, {
    "key": "graphic-designer",
    "name": "Graphic designer",
    "group": "Media & creative"
  }, {
    "key": "writer-author",
    "name": "Writer / author",
    "group": "Media & creative"
  }, {
    "key": "electrician",
    "name": "Electrician",
    "group": "Trades & services"
  }, {
    "key": "mechanic",
    "name": "Mechanic",
    "group": "Trades & services"
  }, {
    "key": "plumber",
    "name": "Plumber",
    "group": "Trades & services"
  }, {
    "key": "tailor",
    "name": "Tailor",
    "group": "Trades & services"
  }, {
    "key": "hairdresser-barber",
    "name": "Hairdresser / barber",
    "group": "Trades & services"
  }, {
    "key": "driver-logistics",
    "name": "Driver / logistics",
    "group": "Trades & services"
  }, {
    "key": "chef-caterer",
    "name": "Chef / caterer",
    "group": "Trades & services"
  }, {
    "key": "trader",
    "name": "Trader",
    "group": "Trades & services"
  }, {
    "key": "student",
    "name": "Student",
    "group": "Other"
  }, {
    "key": "clergy-religious-leader",
    "name": "Clergy / religious leader",
    "group": "Other"
  }, {
    "key": "retired",
    "name": "Retired",
    "group": "Other"
  }, {
    "key": "not-working-at-the-moment",
    "name": "Not working at the moment",
    "group": "Other"
  }],
  "industries": [{
    "key": "agriculture",
    "name": "Agriculture"
  }, {
    "key": "banking-finance",
    "name": "Banking & finance"
  }, {
    "key": "construction-real-estate",
    "name": "Construction & real estate"
  }, {
    "key": "education",
    "name": "Education"
  }, {
    "key": "energy-oil-gas",
    "name": "Energy, oil & gas"
  }, {
    "key": "government-public-sector",
    "name": "Government & public sector"
  }, {
    "key": "healthcare",
    "name": "Healthcare"
  }, {
    "key": "hospitality-tourism",
    "name": "Hospitality & tourism"
  }, {
    "key": "ict-telecoms",
    "name": "ICT & telecoms"
  }, {
    "key": "legal-services",
    "name": "Legal services"
  }, {
    "key": "manufacturing",
    "name": "Manufacturing"
  }, {
    "key": "media-entertainment",
    "name": "Media & entertainment"
  }, {
    "key": "mining-minerals",
    "name": "Mining & minerals"
  }, {
    "key": "ngo-development",
    "name": "NGO & development"
  }, {
    "key": "professional-services",
    "name": "Professional services"
  }, {
    "key": "retail-trade",
    "name": "Retail & trade"
  }, {
    "key": "security-defence",
    "name": "Security & defence"
  }, {
    "key": "transport-logistics",
    "name": "Transport & logistics"
  }, {
    "key": "religious-organisations",
    "name": "Religious organisations"
  }],
  "studies": [{
    "key": "medicine-surgery",
    "name": "Medicine & surgery",
    "group": "Health"
  }, {
    "key": "nursing",
    "name": "Nursing",
    "group": "Health"
  }, {
    "key": "pharmacy",
    "name": "Pharmacy",
    "group": "Health"
  }, {
    "key": "dentistry",
    "name": "Dentistry",
    "group": "Health"
  }, {
    "key": "medical-laboratory-science",
    "name": "Medical laboratory science",
    "group": "Health"
  }, {
    "key": "public-health",
    "name": "Public health",
    "group": "Health"
  }, {
    "key": "other-health-sciences",
    "name": "Other health sciences",
    "group": "Health"
  }, {
    "key": "civil-engineering",
    "name": "Civil engineering",
    "group": "Engineering & technology"
  }, {
    "key": "electrical-electronic-engineering",
    "name": "Electrical / electronic engineering",
    "group": "Engineering & technology"
  }, {
    "key": "mechanical-engineering",
    "name": "Mechanical engineering",
    "group": "Engineering & technology"
  }, {
    "key": "chemical-petroleum-engineering",
    "name": "Chemical / petroleum engineering",
    "group": "Engineering & technology"
  }, {
    "key": "computer-engineering",
    "name": "Computer engineering",
    "group": "Engineering & technology"
  }, {
    "key": "computer-science",
    "name": "Computer science",
    "group": "Engineering & technology"
  }, {
    "key": "information-technology",
    "name": "Information technology",
    "group": "Engineering & technology"
  }, {
    "key": "other-engineering",
    "name": "Other engineering",
    "group": "Engineering & technology"
  }, {
    "key": "mathematics-statistics",
    "name": "Mathematics & statistics",
    "group": "Sciences"
  }, {
    "key": "physics",
    "name": "Physics",
    "group": "Sciences"
  }, {
    "key": "chemistry",
    "name": "Chemistry",
    "group": "Sciences"
  }, {
    "key": "biology-biochemistry",
    "name": "Biology / biochemistry",
    "group": "Sciences"
  }, {
    "key": "geology-earth-sciences",
    "name": "Geology / earth sciences",
    "group": "Sciences"
  }, {
    "key": "agriculture",
    "name": "Agriculture",
    "group": "Sciences"
  }, {
    "key": "environmental-science",
    "name": "Environmental science",
    "group": "Sciences"
  }, {
    "key": "accounting",
    "name": "Accounting",
    "group": "Business & economics"
  }, {
    "key": "economics",
    "name": "Economics",
    "group": "Business & economics"
  }, {
    "key": "banking-finance",
    "name": "Banking & finance",
    "group": "Business & economics"
  }, {
    "key": "business-administration",
    "name": "Business administration",
    "group": "Business & economics"
  }, {
    "key": "marketing",
    "name": "Marketing",
    "group": "Business & economics"
  }, {
    "key": "insurance-actuarial-science",
    "name": "Insurance & actuarial science",
    "group": "Business & economics"
  }, {
    "key": "law",
    "name": "Law",
    "group": "Law & social sciences"
  }, {
    "key": "political-science",
    "name": "Political science",
    "group": "Law & social sciences"
  }, {
    "key": "public-administration",
    "name": "Public administration",
    "group": "Law & social sciences"
  }, {
    "key": "sociology",
    "name": "Sociology",
    "group": "Law & social sciences"
  }, {
    "key": "psychology",
    "name": "Psychology",
    "group": "Law & social sciences"
  }, {
    "key": "international-relations",
    "name": "International relations",
    "group": "Law & social sciences"
  }, {
    "key": "mass-communication-journalism",
    "name": "Mass communication / journalism",
    "group": "Law & social sciences"
  }, {
    "key": "education",
    "name": "Education",
    "group": "Arts & humanities"
  }, {
    "key": "english-literature",
    "name": "English & literature",
    "group": "Arts & humanities"
  }, {
    "key": "languages",
    "name": "Languages",
    "group": "Arts & humanities"
  }, {
    "key": "history",
    "name": "History",
    "group": "Arts & humanities"
  }, {
    "key": "theatre-film-music",
    "name": "Theatre / film / music",
    "group": "Arts & humanities"
  }, {
    "key": "fine-applied-arts",
    "name": "Fine & applied arts",
    "group": "Arts & humanities"
  }, {
    "key": "religious-studies-theology",
    "name": "Religious studies / theology",
    "group": "Arts & humanities"
  }, {
    "key": "architecture",
    "name": "Architecture",
    "group": "Built environment"
  }, {
    "key": "quantity-surveying",
    "name": "Quantity surveying",
    "group": "Built environment"
  }, {
    "key": "estate-management",
    "name": "Estate management",
    "group": "Built environment"
  }, {
    "key": "urban-regional-planning",
    "name": "Urban & regional planning",
    "group": "Built environment"
  }, {
    "key": "vocational-technical-training",
    "name": "Vocational / technical training",
    "group": "Other"
  }, {
    "key": "no-formal-degree",
    "name": "No formal degree",
    "group": "Other"
  }]
};
flarum.reg.add('voucha-community', 'common/taxonomy', __flarum_default_export__);